import styled from "styled-components"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/tabs"
import { Button } from "../../../ui/button"

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../../../ui/dropdown-menu"
import { Input } from "../../../ui/input"

import SimpleTable from '../../components/SimpleTable'
import { useEffect, useState } from "react"
import { useNavigate, useParams } from 'react-router-dom'
import { Alert, Row, Col, Modal, Spin, Toaster, toast, Form, Select } from './../../../ui/ot'
import CheckoutsProTableOt from './../../components/CheckoutsProTableOt'
import { useBorrower } from "../../controllers/BorrowerController"
import { useItem } from './../../controllers/ItemController';
import { useCheckout } from "../../controllers/CheckoutController"
import { useHold } from "../../controllers/HoldController"
import { useLibrary } from "../../controllers/LibraryController"
import HoldsProTableOt from "../../components/HoldsProTableOt"
import { useTranslation } from 'react-i18next';


const CheckOut = ({
    keyPrefix = "library.backstage.Circulation.CheckOut",
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const { borrowernumber } = useParams()
    const navigate = useNavigate()

    const ClaimsDataSource = [
        {
            key: '1',
            title: 'Issue 1',
            notes: 'Details about issue 1',
            createdOn: '2023-06-01',
            updatedOn: '2023-06-02',
            resolution: 'Resolved',
        },
        {
            key: '2',
            title: 'Issue 2',
            notes: 'Details about issue 2',
            createdOn: '2023-06-03',
            updatedOn: '2023-06-04',
            resolution: 'Unresolved',
        },
    ];
    const ClaimsColumns = [
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
        },
        {
            title: 'Created on',
            dataIndex: 'createdOn',
            key: 'createdOn',
        },
        {
            title: 'Updated on',
            dataIndex: 'updatedOn',
            key: 'updatedOn',
        },
        {
            title: 'Resolution',
            dataIndex: 'resolution',
            key: 'resolution',
        },
    ];

    const {
        BorrowerData,
        getBorrowerData,
    } = useBorrower({
        onBefore: () => {

        },
        onFinish: () => {

        }
    })

    const {
        postCheckoutData
    } = useCheckout({
        onFinish: (value) => {
            const axiosMode = value?.axiosMode
            const axiosStatus = value?.status
            switch (axiosMode) {
                case 'post':
                    if (axiosStatus === 'success') toast.success('借閱成功 !')
                    else if (value?.message === "Checkout not authorized (DEBT)") toast.error('借閱失敗 ! 有違規請洽櫃檯。')
                    else toast.error('借閱失敗')
                    break;
                default:
                    break;
            }

        }
    })

    const {
        postHoldData
    } = useHold({
        onFinish: (value) => {
            const axiosMode = value?.axiosMode
            const axiosStatus = value?.status
            switch (axiosMode) {
                case 'post':
                    if (axiosStatus === 'success') toast.success('預約成功 !')
                    else if (value?.message === "Hold cannot be placed. Reason: itemAlreadyOnHold") toast.error('預約失敗 ! 已超過預約數。')
                    else toast.error('預約失敗')
                    break;
                default:
                    break;
            }

        }
    })

    useEffect(() => {
        getBorrowerData({
            borrowernumber: borrowernumber
        })
    }, [borrowernumber])

    const borrower = BorrowerData?.find(_ => true)

    return (
        <>
            <Toaster richColors position="top-center" />
            <MainContainer>
                {/* <Title>{t("borrow")}</Title> */}
                <div hidden>
                    <Row gutter={[8, 8]}>
                        <Col>
                            <Button variant="outline" >{t("edit")}</Button>
                        </Col>
                        <Col>
                            <Button variant="outline" >{t("change_password")}</Button>
                        </Col>
                        <Col>
                            <Button variant="outline" >{t("copy")}</Button>
                        </Col>
                        <Col>
                            <Button variant="outline" >{t("search_reserve")}</Button>
                        </Col>
                        <Col>
                            <DropdownMenu>
                                <DropdownMenuTrigger><Button variant="outline" >{t("print")}</Button></DropdownMenuTrigger>
                                <DropdownMenuContent>
                                    <DropdownMenuItem>{t("print_summary")}</DropdownMenuItem>
                                    <DropdownMenuItem>{t("print_slip")}</DropdownMenuItem>
                                    <DropdownMenuItem>{t("print_quick_slip")}</DropdownMenuItem>
                                    <DropdownMenuItem>{t("print_checkin_slip")}</DropdownMenuItem>
                                </DropdownMenuContent>
                            </DropdownMenu>
                        </Col>
                        <Col>
                            <Button variant="outline" >{t("add_message")}</Button>
                        </Col>
                        <Col>
                            <DropdownMenu>
                                <DropdownMenuTrigger><Button variant="outline" >{t("more")}</Button></DropdownMenuTrigger>
                                <DropdownMenuContent>
                                    <DropdownMenuItem>{t("renew_patron")}</DropdownMenuItem>
                                    <DropdownMenuItem>{t("set_permissions")}</DropdownMenuItem>
                                    <DropdownMenuItem>{t("manage_api_key")}</DropdownMenuItem>
                                    <DropdownMenuItem>{t("send_welcome_email")}</DropdownMenuItem>
                                    <DropdownMenuItem>{t("delete")}</DropdownMenuItem>
                                </DropdownMenuContent>
                            </DropdownMenu>
                        </Col>
                    </Row>
                </div>
                <LanContainer>
                    <WhiteBox>
                        <Row gutter={[8, 8]}>
                            <CheckoutForm
                                borrowernumber={borrowernumber}
                                borrower={borrower}
                                onCheckout={({ itemnumber }) => postCheckoutData([
                                    {
                                        borrowernumber: borrowernumber,
                                        itemnumber: itemnumber
                                    }
                                ])}
                                onHold={({ itemnumber, pickupLibrary }) => postHoldData([
                                    {
                                        borrowernumber: borrowernumber,
                                        itemnumber: itemnumber,
                                        pickupLibrary: pickupLibrary
                                    }
                                ])}
                            />
                        </Row>
                    </WhiteBox>
                    <WhiteBox hidden>
                        <SubTitle>{t("message")}</SubTitle>
                        <Button variant="link">+ {t("add_new_message")}</Button>
                    </WhiteBox>
                </LanContainer>
                <Tabs defaultValue="0" className="w-full">
                    <TabsList>
                        <TabsTrigger value="0">{t("borrowed")}</TabsTrigger>
                        <TabsTrigger value="1">{t("reservation")}</TabsTrigger>
                        <TabsTrigger value="2" disabled>{t("declaration")}</TabsTrigger>
                        <TabsTrigger value="3" disabled>{t("restriction")}</TabsTrigger>
                        <TabsTrigger value="4" disabled>{t("reader_list")}</TabsTrigger>
                    </TabsList>
                    <TabsContent value="0">
                        <WhiteBox>
                            <CheckoutsProTableOt
                                borrowernumber={borrowernumber}
                                // keyPrefix={keyPrefix + ".borrowed_list"}
                            />
                        </WhiteBox>
                    </TabsContent>
                    <TabsContent value="1">
                        <WhiteBox>
                            <HoldsProTableOt
                                borrowernumber={borrowernumber}
                            />
                        </WhiteBox>
                    </TabsContent>
                    <TabsContent value="2">
                        <WhiteBox>
                            <SimpleTable columns={ClaimsColumns} dataSource={ClaimsDataSource} />
                        </WhiteBox>
                    </TabsContent>
                    <TabsContent value="3">
                        <WhiteBox>
                            <div>
                                <span>{t("patron_unrestricted")}</span>
                            </div>
                            <Button variant="link">{t("manual_add_restriction")}</Button>
                        </WhiteBox>
                    </TabsContent>
                    <TabsContent value="4">
                        <WhiteBox>
                        </WhiteBox>
                    </TabsContent>
                </Tabs>
            </MainContainer>
        </>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
// padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const LanContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: row;
-webkit-box-align: start;
align-items: start;
gap: 0.5em;
flex-wrap: nowrap;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.1em;
font-weight: 600;
padding-bottom: 0.5em;
}
`

const WhiteBox = styled.div`
background - color: #fff;
padding: 1em;
width: -webkit - fill - available;
`
const GrayText = styled.span`
color: #929292;
`

const Title = styled.div`
text - align: left;
width: 90 %;
font - size: 1.6em;
font - weight: 700;
}
`

export default CheckOut

const CheckoutForm = ({
    keyPrefix = "library.backstage.Circulation.CheckOut",
    borrower = {},
    borrowernumber,
    onCheckout = () => { },
    onHold = () => { },
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const [barcode, setBarcode] = useState('');
    const [modealOpen, setModalOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const onCheckoutClick = () => {
        setModalOpen(true)
        getItemData({
            barcode: barcode,
            borrowernumber: borrowernumber
        })
    }


    const {
        ItemData,
        getItemData
    } = useItem({
        onBefore: () => {
            setLoading(true)
        },
        onFinish: () => {
            setLoading(false)
        },
    })

    return <>
        <CheckoutModal
            borrowernumber={borrowernumber}
            ItemData={ItemData}
            loading={loading}
            open={modealOpen}
            setOpen={setModalOpen}
            onFinish={({
                mode,
                pickupLibrary,
                ...props
            }) => {
                if (mode === "hold") {
                    onHold({
                        itemnumber: ItemData?.find(_ => true)?.item_itemnumber,
                        pickupLibrary,
                    })
                } else if (mode === "checkout") {
                    onCheckout({
                        itemnumber: ItemData?.find(_ => true)?.item_itemnumber
                    })
                }
            }}
        />
        <Col span={24}>
            <SubTitle>{t("patron")} : {borrower?.surname} ({borrower?.cardnumber})</SubTitle>
            <LanContainer>
                <Input placeholder='Enter item barcode' onChange={e => setBarcode(e.target.value)} />
                <Button onClick={onCheckoutClick}>{t("borrowing")}</Button>
            </LanContainer>
        </Col>
    </>
}
const CheckoutModal = ({
    keyPrefix = "library.backstage.Circulation.CheckOut",
    open: externalOpen,
    setOpen: externalSetOpen,
    onFinish = () => { },
    ItemData = [],
    loading = false
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const [form] = Form.useForm()
    const [internalOpen, setInternalOpen] = useState(false);

    const isControlled = externalOpen !== undefined && externalSetOpen !== undefined;
    const open = isControlled ? externalOpen : internalOpen;
    const setOpen = isControlled ? externalSetOpen : setInternalOpen;


    const handleOk = () => {
        setOpen(false);
        form.submit()
    };

    const handleCancel = () => {
        setOpen(false);
    };

    const handleOpenModal = () => {
        setOpen(true);
    };
    const onFormFinish = () => {
        if (itemData?.issue_cancheckout === 1) {
            onFinish({
                mode: 'checkout',
                ...form.getValues()
            });
        } else if (itemData?.reserve_canhold === 1) {
            onFinish({
                mode: 'hold',
                ...form.getValues()
            });
        }
    }

    const {
        LibraryData,
        getLibraryData
    } = useLibrary({

    })

    useEffect(() => {
        getLibraryData({})
    }, [])
    const itemData = ItemData?.find(_ => true)
    return <>
        {open && <Modal
            open={open}
            title={t("library_collection_borrowing")}
            okText={itemData?.issue_cancheckout === 1 ? t("borrowing") : t("reservation")}
            okProps={{
                disabled: itemData?.issue_cancheckout === 0 && itemData?.reserve_canhold === 0
            }}
            cancelText={t("cancel")}
            onCancel={handleCancel}
            onOk={handleOk}
        >
            {loading && <Spin />}
            {!loading && ItemData.length === 0 && <>{t("book_not_found")}</>}
            {!loading && itemData && <>
                {itemData?.bib_title}{itemData?.bib_subtitle}{itemData?.bib_author}
                <Form
                    form={form}
                    onFinish={onFormFinish}
                >
                    {itemData?.issue_cancheckout === 0 && itemData?.reserve_canhold === 1 && <>
                        <Form.Item
                            label={t("pickup_branch")}
                            name="pickupLibrary"
                        >
                            <Select
                                options={LibraryData.map(item => (
                                    {
                                        label: item?.branchname,
                                        value: item?.branchcode
                                    }
                                ))}
                            />
                        </Form.Item>
                    </>}
                </Form>
            </>}
        </Modal>}
    </>
}